.chooser {
  display: flex;
  margin: 6px 0;
}

.pill {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-height: 38px;
  padding: 6px 16px;
  border-radius: 5px;
  font-size: 0.95rem;
  cursor: pointer;
  user-select: none;
  background-color: #ccd9d4;
  color: #1c2925;
  border: 1px solid #93aca3;
}
.pill.filtering {
  background-color: #1d7a60;
  color: white;
  border-color: #1d7a60;
}

.pillName {
  max-width: 50vw;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.option {
  padding: 10px 14px;
  border-radius: 5px;
  font-size: 0.95rem;
  cursor: pointer;
  user-select: none;
  color: #1c2925;
}
.option.active {
  background-color: #1d7a60;
  color: white;
}

:global(.dark) .pill {
  background-color: #223431;
  color: #c8dcd6;
  border-color: #3a544e;
}
:global(.dark) .pill.filtering {
  background-color: #1d7a60;
  color: #eafff8;
  border-color: #1d7a60;
}
:global(.dark) .option {
  color: #cfe0da;
}
:global(.dark) .option.active {
  background-color: #1d7a60;
  color: #eafff8;
}
:global(.dark) .pop {
  --bs-popover-bg: #182420;
  --bs-popover-body-color: #cfe0da;
  --bs-popover-border-color: #2c3c3a;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */